<template>
  <div id="app">
    <!-- <TopNav :class=" topStyle === false ? 'tv' : 'tv tv-active'"></TopNav> -->
    <router-view class="rv"></router-view>
    <!-- <BottomNav></BottomNav> -->
  </div>
</template>

<script>
  // import {Time} from './config/time'
  // import TopNav from './views/common/public/topNav'
  // import BottomNav from './views/common/public/bottomNav'

  // import 'quill/dist/quill.core.css'
  // import 'quill/dist/quill.snow.css'
  // import 'quill/dist/quill.bubble.css'
  // import '@/assets/css/quill.bubble.css';
  // import '@/assets/css/quill.core.css';
  // import '@/assets/css/quill.snow.css';

  export default {
    name: 'App',
    components: {
      // TopNav,
      // BottomNav
    },
    data() {
      return {
        // 导航栏的样式
        topStyle: false,
        fromView: '',
        toView: '',
        inTime: '',
        sId: ''
      }
    },
    mounted () {
      // document.addEventListener('click', e => {
      //   // 先尝试获取元素本身的 fillingPoint(埋点)
      //   let fillingPoint = e.target.dataset.fillingPoint

      //   /**
      //    * 如果上面没有获取到
      //    * 说明这个元素可能是个组件
      //    * 或者根本就没有设置埋点
      //    * 下面尝试获取是组件的情况
      //    */
      //   if (!fillingPoint) {
      //     const parents = e.path.slice(0, -5)
      //     for (let i = 1, len = parents.length; i < len; i++) {
      //       fillingPoint = parents[i].dataset.fillingPoint

      //       if (fillingPoint) {
      //         console.log(fillingPoint)
      //         break
      //       }
      //     }
      //   }

      //   /**
      //    * 经过上面的查找
      //    * 如果找到了fillingPoint
      //    * 那就可以发请求了
      //    * 没有找到就没有fillingPoint了
      //    */
      //   if (fillingPoint) {
      //     this.http.post('/traffic/addEventTracking', {
      //         pointId: fillingPoint
      //     }) 
      //   }
      // }, false)

      // window.addEventListener('scroll',this.scrollHandle);
    },
    // activated() {
    //   console.log(this.inTime)
    //   // const time = new Date().getTime()
    //   // this.inTime = Time.format(time)
    //   // console.log(this.inTime)
    // },
    methods: {
      scrollHandle(e) {
        let top = e.srcElement.scrollingElement.scrollTop;    // 获取页面滚动高度
        if(top >= 600) {
          this.topStyle = true
        }
        if(top < 600) {
          this.topStyle = false
        }
      }
    },
    watch: {
      // 监听路由变化---页面浏览量统计
      // $route(to, from){
      //   let time = new Date().getTime()
      //   let outTime = Time.format(time)
      //   if(this.inTime !== '') {
      //     this.http.post('/traffic/addPv', {
      //       pageSourceId: this.sId,
      //       pageId: from.meta.id,
      //       inTime: this.inTime,
      //       outTime: outTime,
      //       token: this.$store.state.login.token
      //     })
      //   }
      //   this.sId = from.meta.id
      //   this.inTime = Time.format(time) 
      // }
    },
  }
</script>

<style>

  /* @import './assets/css/quill.bubble.css';
  @import './assets/css/quill.bubble.css';
  @import './assets/css/quill.snow.css'; */

*{
  margin: 0;
  padding: 0;
  /* font-family: "Microsoft YaHei"; */
  font-family: 'Heiti SC';
}

.tv {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}
.tv-active {
  box-shadow: 0px 8px 8px 2px #dce5ff4a;
}
.rv {
  /* margin-top: 100px; */
}
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
      -webkit-appearance: none !important;
  }
  input[type="number"] {-moz-appearance: textfield;}
</style>
